import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import "./App.css";
import reportWebVitals from "./reportWebVitals";

// MUI DataGrid can trigger a harmless ResizeObserver loop in dev.
const ResizeObserverOriginal = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends ResizeObserverOriginal {
  constructor(callback) {
    super((entries, observer) => {
      window.requestAnimationFrame(() => callback(entries, observer));
    });
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
